import upload from './src'

export default upload



// WEBPACK FOOTER //
// ./components/vc-upload/index.js